<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useQuery } from '@tanstack/vue-query'
import { memberActivitiesApi } from '@/api/member'
import { useSessionStore } from '@/stores/session'
import FloatGif from '@/assets/raffle/float.gif'

const DISMISS_STORAGE_KEY = 'lucky_wheel_float_dismissed_until'
const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000

const router = useRouter()
const sessionStore = useSessionStore()
const dismissed = ref(isDismissed())

const { data: activitiesData } = useQuery({
  queryKey: ['member-activities'],
  queryFn: async () => {
    const res = await memberActivitiesApi()
    return res.data
  },
  enabled: () => !!sessionStore.sessionId,
})

const luckyWheel = computed(() => activitiesData.value?.lucky_wheel ?? null)

const visible = computed(() => !!luckyWheel.value && !dismissed.value)

function isDismissed(): boolean {
  const until = localStorage.getItem(DISMISS_STORAGE_KEY)
  if (!until) return false
  return Date.now() < Number(until)
}

const handleClick = () => {
  router.push('/activity/lucky-wheel')
}

const handleDismiss = () => {
  localStorage.setItem(DISMISS_STORAGE_KEY, String(Date.now() + DISMISS_DURATION_MS))
  dismissed.value = true
}
</script>

<template>
  <div
    v-if="visible"
    class="fixed right-1 z-50 bottom-[calc(72px+env(safe-area-inset-bottom,0px)+8px)]"
  >
    <div class="relative size-[90px]">
      <button
        type="button"
        class="absolute -top-1 -right-1 z-10 flex size-5 items-center justify-center rounded-full bg-black/45 text-white active:opacity-80"
        aria-label="关闭"
        @click.stop="handleDismiss"
      >
        <van-icon name="cross" size="16" class="text-white!" />
      </button>

      <button
        type="button"
        class="block size-[90px] active:scale-95 transition-transform"
        aria-label="幸运大转盘"
        @click="handleClick"
      >
        <img :src="FloatGif" alt="幸运大转盘" class="size-[90px] pointer-events-none" />
      </button>
    </div>
  </div>
</template>
